import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = {
  class: "body",
  "data-test": "modal-body-skeleton"
}
const _hoisted_3 = { class: "button-wrapper" }

import { IonModal, IonTitle } from "@ionic/vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'AppModalSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!

  return (_openBlock(), _createBlock(_unref(IonModal), {
    "data-test": "app-modal-skeleton",
    "backdrop-dismiss": false,
    "is-open": true,
    role: "dialog",
    "aria-hidden": "true",
    "aria-busy": "true"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IonTitle), {
          size: "small",
          "data-test": "modal-title-skeleton"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_skeleton_text, {
              animated: true,
              style: {"width":"60%","height":"28px"}
            })
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_2, [
          _createVNode(_component_ion_skeleton_text, {
            animated: true,
            style: {"width":"100%","height":"16px","margin-bottom":"4px"}
          }),
          _createVNode(_component_ion_skeleton_text, {
            animated: true,
            style: {"width":"100%","height":"16px"}
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ion_skeleton_text, {
            "data-test": "modal-button",
            animated: true,
            class: "button",
            style: {"width":"100%","height":"44px"}
          }),
          _createVNode(_component_ion_skeleton_text, {
            "data-test": "modal-button",
            animated: true,
            class: "button",
            style: {"width":"100%","height":"44px"}
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})